import { Reducer } from 'redux';
import { SearchActionTypes, SearchState } from './types';

export const initialState: SearchState = {
  search: undefined,
  test: true
};

const reducer: Reducer<SearchState> = (state = initialState, action) => {
  switch (action.type) {
    case SearchActionTypes.SAVE_SEARCH: {
      return { ...state, search: action.payload };
    }
    default: {
      return state;
    }
  }
};

export { reducer as searchReducer };

